/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useHeaderStates } from '../../Providers/HeaderStates';
import { ContactUs } from '../../components/ContactUs';
import { useStartupState } from '../../Providers/StartupState';
import { baseUrlImg, handleGetData } from '../../Api';
import { Loading } from '../../components/Loading';
import { Capa } from '../../components/Capa';
import { ReactMarkdown } from 'react-markdown/lib/react-markdown';
import * as S from './style';

export const Wiring = () => {
  const [data, setData] = useState(null);
  const [selectedPhoto, setSelectedPhoto] = useState(null);

  const { setTitle, setBgHeader } = useHeaderStates();
  const { token, setError, loading, setLoading } = useStartupState();

  useEffect(() => {
    setError(null);
    setLoading(true);
    if (token) {
      handleGetData(token, 'api/content/copasul/fiacao/')
        .then((response) => {
          setData(response?.data?.items[0]?.data);
          if (response?.status !== 200) {
            throw new Error(response.message);
          }
        })
        .catch((e) => {
          setData(null);
          console.log(e.message);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [token]);

  // A página tem a própria capa: a faixa verde com o título, que o Header
  // desenha a partir do setTitle, fica desligada.
  useEffect(() => {
    setTitle(null);
    setBgHeader(null);
  }, [setTitle, setBgHeader]);

  /* const handleResize = () => {
    if (!data) return;
    if (window.innerWidth <= 800) {
      setBgImg(data?.imagemFundoMobile?.iv?.[0]);
      data?.imagemCotacao?.iv?.length >= 1 && setPriceImg(data?.imagemCotacao?.iv?.[0]);
    } else if (window.innerWidth > 800 && window.innerWidth <= 1100) {
      setBgImg(data?.imagemFundoWeb?.iv?.[0]);
      data?.imagemCotacao?.iv?.length >= 2 && setPriceImg(data?.imagemCotacao?.iv?.[1]);
    } else if (window.innerWidth > 1100) {
      setBgImg(data?.imagemFundoWeb?.iv?.[0]);
      data?.imagemCotacao?.iv?.length >= 2 && setPriceImg(data?.imagemCotacao?.iv?.[1]);
    }
  }; */

  if (loading) {
    return <Loading />;
  } else {
    return (
      <>
        <Capa
          imagem={[data?.imagemFundoWeb?.iv?.[0], data?.imagemHeader?.iv?.[0]]}
          titulo={data?.seo?.iv?.TituloSEO}
        />

        <S.Container>

          <S.DescriptionBox>
            <h1>{data?.Descricao?.iv[0]?.DescricaoCard?.CardIndustrias[0]?.Titulo}</h1>
            <ReactMarkdown
              className="ReactMarkdown"
              children={data?.Descricao?.iv[0]?.DescricaoCard?.CardIndustrias[0]?.Conteudo}
            />
          </S.DescriptionBox>

          <S.CardBox>
            <h1>{data?.DescricaoCards?.iv[0]?.Titulo}</h1>
            <S.IconsWrapper>
              {data?.DescricaoCards?.iv[0]?.DescricaoCard?.CardIndustrias?.map((industria, index) => (
                <S.IconBox key={index}>
                  <img src={`${baseUrlImg}${industria.Imagem}`} alt={`Ícone ${index}`} />
                  <h2>{industria?.Titulo}</h2>
                </S.IconBox>
              ))}
            </S.IconsWrapper>
          </S.CardBox>
          {/* <LatestNews BGColor={'#3d362f'} /> */}
        </S.Container>

        <S.PhotoWrapper>
      <h1>{data?.FotosFiacao?.iv[0]?.Titulo}</h1>

      <S.PhotoWiring>
        {data?.FotosFiacao?.iv[0]?.Fotos?.imagens?.map((foto, index) =>
          foto?.imagem?.[0] && (
            <S.Card
              key={index}
              onClick={() => setSelectedPhoto(`${baseUrlImg}${foto.imagem[0]}`)}
            >
              <img
                src={`${baseUrlImg}${foto.imagem[0]}`}
                alt={`Foto ${index}`}
              />
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7"
                />
              </svg>
            </S.Card>
          )
        )}
      </S.PhotoWiring>

      {selectedPhoto && (
        <S.ModalBackdrop onClick={() => setSelectedPhoto(null)}>
          <S.ModalContent>
            <img src={selectedPhoto} alt="Foto ampliada" />
            <button onClick={() => setSelectedPhoto(null)}>
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </S.ModalContent>
        </S.ModalBackdrop>
      )}
    </S.PhotoWrapper>
        {/* <LinkServices
          linksServices={data?.links?.iv}
          BGColor={'#3d362f'}
        /> */}
        <ContactUs />
      </>
    );
  }
};
